import React from 'react';
import { BaseMeta } from 'types';
import { HeroBanner } from 'types/generated/graphql';
import Slide from '../components/Slide';

const getSlide = (heroBanner: HeroBanner) => {
    const {
        guid,
        title,
        byline,
        description,
        instruments,
        genres,
        contentType,
        entity,
        labelPacks,
    } = heroBanner;

    const tags = [...(genres ?? []), ...(instruments ?? [])] as BaseMeta[];

    return (
        <Slide
            key={guid}
            guid={guid}
            contentType={contentType}
            title={title}
            byline={byline}
            description={description}
            tags={tags}
            entity={entity}
            labelPacks={labelPacks}
        />
    );
};

export default getSlide;
